import { useCallback, useState } from 'react';

type Params = { startOn: string; endOn: string };

export const useTransportSystemLedgerExport = ({ startOn, endOn }: Params) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = useCallback(() => setDialogOpen(true), []);
  const closeDialog = useCallback(() => setDialogOpen(false), []);

  const handleConfirm = useCallback(
    (selected: string[]) => {
      const query = new URLSearchParams();
      query.set('start_on', startOn);
      query.set('end_on', endOn);
      selected.forEach((name) => query.append('shipper_names[]', name));
      // 添付ダウンロードなので現在タブで起動し、空タブを残さない
      window.open(`/api/v5/reports/transport_system_ledgers?${query.toString()}`, '_self');
      setDialogOpen(false);
    },
    [startOn, endOn],
  );

  return {
    dialogOpen, openDialog, closeDialog, handleConfirm,
  };
};
